export type Theme = 'light' | 'dark';

const THEME_STORAGE_KEY = 'theme';

/**
 * Obtiene el tema actual del sistema o del localStorage
 */
export function getInitialTheme(): Theme {
  const savedTheme = localStorage.getItem(THEME_STORAGE_KEY) as Theme | null;
  if (savedTheme) {
    return savedTheme;
  }

  // Detectar preferencia del sistema
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  return 'light';
}

/**
 * Aplica un tema al documento
 */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  
  localStorage.setItem(THEME_STORAGE_KEY, theme);
}

/**
 * Alterna entre tema claro y oscuro
 */
export function toggleTheme(): Theme {
  const currentTheme = getInitialTheme();
  const newTheme: Theme = currentTheme === 'light' ? 'dark' : 'light';
  applyTheme(newTheme);
  return newTheme;
}

/**
 * Inicializa el tema al cargar la aplicación
 */
export function initializeTheme(): void {
  const theme = getInitialTheme();
  applyTheme(theme);
}
